module.exports = __webpack_public_path__ + "static/media/5-6.b5beb742.mp3";